

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { RegistrationAnswer } from "@/model/RegistrationAnswer";

    @Component({})
    export default class PagePart extends Vue {

        // mounted(): void {
        // }

        @Prop({ required: true })
        registrationAnswer!: RegistrationAnswer;

        @Prop({ required: true })
        pathwayId!: string;

        get rules(): Array<(() => string | boolean) | ((v: any) => string | true)> {
            const validator = (v: any) => !!v || "Please enter a response";
            return this.registrationAnswer.isMandatory && this.registrationAnswer.canShowForPathway(this.pathwayId) ? [ validator ] : [];
        }

        onInput(text: string) {
            this.registrationAnswer.value = text;
            this.$emit("input", text);
        }
    }
